export default function getNetlifyHeaders({ trustToken }) {
    if (!trustToken) {
        return undefined;
    }
    return { 'x-netlify-trusted-token': trustToken };
}
//# sourceMappingURL=getNetlifyHeaders.js.map